import { request } from '@/services/http';

/**
 * Wrapper statique legacy — délègue au client HTTP central `@/services/http`.
 *
 * Conservé pour compatibilité avec les services `@/data/services/*` qui
 * appellent `HttpService.get/post/put/...`. Aucun `as` ici : le seul cast
 * typé du pipeline fetch est centralisé dans `@/services/http` (règle §16).
 *
 * Les nouveaux services doivent importer directement `request` ou l'objet
 * `http` depuis `@/services/http`.
 */
export class HttpService {
    static async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
        const { body, ...rest } = options;
        return request<T>(endpoint, {
            ...rest,
            rawBody: body ?? undefined,
        });
    }

    static async get<T>(endpoint: string): Promise<T> {
        return request<T>(endpoint, { method: 'GET' });
    }

    static async post<T>(endpoint: string, data?: unknown): Promise<T> {
        return request<T>(endpoint, { method: 'POST', json: data });
    }

    static async put<T>(endpoint: string, data?: unknown): Promise<T> {
        return request<T>(endpoint, { method: 'PUT', json: data });
    }

    static async patch<T>(endpoint: string, data?: unknown): Promise<T> {
        return request<T>(endpoint, { method: 'PATCH', json: data });
    }

    static async delete<T>(endpoint: string): Promise<T> {
        return request<T>(endpoint, { method: 'DELETE' });
    }
}
